export function CARD_TYPE () {
  return [{
    value: 1,
    name: '实物兑换券'
  },
  {
    value: 2,
    name: '活动券'
  },
  {
    value: 3,
    name: '代金券'
  }
  ]
}
export const PRODUCT_RADIO = Object.freeze({
  appoint: '2',
  all: '1'
})
//cardTicketType
export const CAR_TICKET_TYPE = [{
  value: 0,
  name: '全部'
},
{
  value: 1,
  name: '实物兑换券'
},
{
  value: 2,
  name: '活动券'
},
{
  value: 3,
  name: '代金券'
}
]